The previous state of the application or position.

This is an optional field, and can be omitted if your software does not track this information.
